import React from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Layout from './Layout'
import Chat from './Chat'
import Networks from './Networks'
import Staff from './Staff'
import SearchReclips from './SearchReclips'
import VectorSearch from './VectorSearch'
import Deepgram from './Deepgram'
import Swagger from './Swagger'
import Settings from './Settings'
import SlackCallback from './SlackCallback'
import ReclipsMap from './ReclipsMap'
import ReclipPlayer from './ReclipPlayer'
import SharePlayer from './SharePlayer'
import GPT from './GPT'
import Tags from './Tags'
import Schools from './Schools'
import Reactions from './Reactions'
import TeamReclipStory from './TeamReclipStory'
import EvergreenSuggestions from './EvergreenSuggestions'
import OnboardingSuggestions from './OnboardingSuggestions'
import Harsh from './Harsh'
import FreePhoneNumbers from './FreePhoneNumbers'
import Chatbots from './Chatbots'
import Tools from './Tools'
import AnimationStyles from './Tools/AnimationStyles'
import Cost from './Cost'
import Heartbeats from './Heartbeats'
import StreamIngest from './StreamIngest'
import Overview from './Overview'
import Loop from './Loop'
import Moments from './Moments'
import Users from './Users'
import Reports from './Reports'
import More from './More'
import Report from './Reports/Report'
import { useAuth } from 'store/selectors'
import { CHAT_ONLY_USER_IDS, TOOLS_ONLY_USER_IDS } from 'const'

// Stream Ingest is the Pipeline page now. Links from before the rename carry
// an account and a span (`?user=&name=&span=`), so the query goes with them.
const RenamedToPipeline = () => {
  const { search } = useLocation()
  return <Navigate to={`/pipeline${search}`} replace />
}

const Main = () => {
  const { user } = useAuth()

  if (CHAT_ONLY_USER_IDS.includes(user.id))
    return (
      <Layout>
        <Routes>
          <Route path="/chat/*" element={<Chat />} />
          <Route path="/more" element={<More />} />
          <Route path="/settings/slack/callback" element={<SlackCallback />} />
          <Route path="*" element={<Navigate to="/chat" replace />} />
        </Routes>
      </Layout>
    )

  if (TOOLS_ONLY_USER_IDS.includes(user.id))
    return (
      <Layout>
        <Routes>
          <Route path="/tools" element={<Tools />} />
          <Route path="/more" element={<More />} />
          <Route path="*" element={<Navigate to="/tools" replace />} />
        </Routes>
      </Layout>
    )

  return (
    <Layout>
      <Routes>
        <Route path="/chat/*" element={<Chat />} />
        <Route path="/users" element={<Users />} />
        <Route path="/networks" element={<Networks />} />
        <Route path="/staff" element={<Staff />} />
        <Route path="/search" element={<SearchReclips />} />
        <Route path="/moments" element={<Moments />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/reports/:reportId" element={<Report />} />
        <Route path="/more" element={<More />} />
        <Route path="/vector-search" element={<VectorSearch />} />
        <Route path="/transcription" element={<Deepgram />} />
        <Route path="/swagger/*" element={<Swagger />} />
        <Route path="/map" element={<ReclipsMap />} />
        <Route path="/r/:source_id" element={<ReclipPlayer />} />
        <Route path="/s/:share_code" element={<SharePlayer />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/settings/slack/callback" element={<SlackCallback />} />
        <Route path="/gpt" element={<GPT />} />
        <Route path="/tags" element={<Tags />} />
        <Route path="/schools" element={<Schools />} />
        <Route path="/reactions" element={<Reactions />} />
        <Route path="/team-reclip-story" element={<TeamReclipStory />} />
        <Route path="/evergreen" element={<EvergreenSuggestions />} />
        <Route path="/onboarding" element={<OnboardingSuggestions />} />
        <Route path="/harsh" element={<Harsh />} />
        <Route path="/free-phone-numbers" element={<FreePhoneNumbers />} />
        <Route path="/chatbots/*" element={<Chatbots />} />
        <Route path="/animation-styles" element={<AnimationStyles />} />
        <Route path="/cost" element={<Cost />} />
        <Route
          path="/kill-switch"
          element={<Navigate to="/cost?tab=animation" replace />}
        />
        <Route path="/heartbeats" element={<Heartbeats />} />
        <Route path="/overview" element={<Overview />} />
        <Route path="/pipeline" element={<StreamIngest />} />
        <Route path="/loop" element={<Loop />} />
        <Route path="/stream-ingest" element={<RenamedToPipeline />} />
        <Route path="/tools" element={<Tools />} />
        <Route path="*" element={<Navigate to="/chat" replace />} />
      </Routes>
    </Layout>
  )
}

export default Main
